import { render } from "./CardsFilter.vue?vue&type=template&id=3794e228&ts=true"
import script from "./CardsFilter.vue?vue&type=script&lang=ts"
export * from "./CardsFilter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__